import {Component} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {BadgeComponent} from "../../badge/badge.component";
import {Select2BadgesComponent} from "../../select2-badges/select2-badges.component";
import {FIELD_VIEW_PROVIDERS, FieldsBaseComponent} from "../fields-base/fields-base.component";

@Component({
    selector: 'app-select-badge-field',
    imports: [
        CommonModule,
        FieldsBaseComponent,
        ReactiveFormsModule,
        BadgeComponent,
        Select2BadgesComponent
    ],
    templateUrl: './select-badge-field.component.html',
    styleUrl: './select-badge-field.component.scss',
    viewProviders: FIELD_VIEW_PROVIDERS
})
export class SelectBadgeFieldComponent extends FieldsBaseComponent<string> {
}
